import Collapse from 'bootstrap/js/dist/collapse'

import {
    searchLink,
} from './module_common';

import { 
    attachSignInRedirect,
    handleNavbarOpenLoginModal,
    attachDocumentLeaveForRetarget,
    logoutAndReload,
 } from './module_auth_helper';

let mobileSearchInputMustBeInit = true
let deskSearchInputMustBeInit = true

let tempMobileElement = null;

const desktopSearchSelector = ".desk-lens-attach-clk";
const mobileSearchId = "mobile-lens-attach-clk";
const mobileSearchSelector = "#"+mobileSearchId;
const formClassSelector = ".search-form"

const desktopSearchFormList = $(".desktop-li-seach-form")
const mobileSearchModal = $("#searchModalId")
const mobileSearchInput = $(".mob-search-input")
const mobileFormSubmit = $(".mob-submit-attach-clk")
const deskFormSubmit = $('.desk-submit-attach-clk')
const navItemsRegular = $(".nav-item.hide-on-search")
const deskSearchInput = $(".desk-search-input")

const handleMobileNavBarOpen = function(){
    $('#navbarSupportedContent').on('show.bs.collapse', function () {
        $('header').addClass("show-collapsed")
        $('body').addClass("mobile-menu-open")
        $(document).on("click", manageClickOutsideMobileNavBar)
    })

    $('#navbarSupportedContent').on('hidden.bs.collapse', function () {
        $('header').removeClass("show-collapsed")
        $('body').removeClass("mobile-menu-open")
        $(document).off("click", manageClickOutsideMobileNavBar)
    })
}

function manageClickOutsideMobileNavBar(e){
    var clickover = $(e.target);
    var _opened = $(".navbar-collapse").hasClass("show");
    
    if (_opened === true && clickover.hasClass("body-opacity-js-ref")) {
        closeMobileNavbar()
    }
}

const handleDesktopNavBarScroll = function(){
    // https://bootstrap-menu.com/detail-autohide.html
    const el_autohide = document.querySelector('.navbar.autohide');

    const el_fixed_on_scroll = document.querySelector('.navbar.fixed-on-scroll-notlogged');
    
    const header = $('header');

    let last_scroll = ""
    const inertia_y = 30

    if(el_autohide){
        // to know if we go up or down
        var last_scroll_Y = 0;

        // to got inertia
        let last_position_up = window.scrollY
        let last_position_down = window.scrollY
        
        window.addEventListener('scroll', function() {
            
            // do not close menu if open
            if (header.hasClass("show-collapsed")) {
                return;
            }

            $('.profile-dropdown-item.show').dropdown('toggle')
            
            // always show header when we are on top
            if (window.scrollY < 50) {
                el_autohide.classList.remove('scrolled-down');
                el_autohide.classList.add('scrolled-up');
                return;
            }

            let scroll_Y = window.scrollY;
            if(scroll_Y < last_scroll_Y) {
                // going up...
                if (last_scroll === '') {
                    last_scroll = 'up'
                    return
                }
                if ((last_position_down - scroll_Y) < inertia_y) return
                
                el_autohide.classList.remove('scrolled-down');
                el_autohide.classList.add('scrolled-up');
                last_position_up = scroll_Y
            }
            else {
                // going down...
                if (last_scroll === '') {
                    last_scroll = 'down'
                    return
                }
                if ((scroll_Y - last_position_up) < inertia_y) return
                
                closeDesktopSearchIfIsOpen()
                el_autohide.classList.remove('scrolled-up');
                el_autohide.classList.add('scrolled-down');
                last_position_down = scroll_Y
            }
            last_scroll_Y = scroll_Y;
        }); 
    }

    if (el_fixed_on_scroll){
        handleNavFixedOnScroll(el_fixed_on_scroll)
        window.addEventListener('scroll', function() {
            handleNavFixedOnScroll(el_fixed_on_scroll)
        })
    }
}

const handleNavFixedOnScroll = function(el){
    const cl = el.classList 
    const isHidden = cl.contains('fixed-on-scroll-notlogged-hidden')
    if (window.scrollY > 200){
        if (isHidden) cl.remove("fixed-on-scroll-notlogged-hidden")
    } else if (!isHidden){
        cl.add("fixed-on-scroll-notlogged-hidden")
    }
}

const attachLogout = function(){
    $(".logout-attach-clk").on('click', function(){
        logoutAndReload()
    })
}

const attachNavBarLoginClick = function(){
    $(".login-attach-clk").on('click', function(e){
        handleNavbarOpenLoginModal(e)
    })
}

// --- search functions start ---

function formSubmitInit(){
    $(formClassSelector).on('submit', function(e){
        e.preventDefault()
        onFormSubmit(e.currentTarget)
    })
}

function mobileFormInit(){
    manageVirtualKeyboard()

    mobileSearchModal.on('shown.bs.modal', function(){
        $(".mobile-search-column input").focus()
        if (tempMobileElement){
            document.body.removeChild(tempMobileElement)
            tempMobileElement = null
        }
        if (mobileSearchInputMustBeInit){
            mobileSearchInputMustBeInit = false
            mobileSearchInput.on("input", function(e){
                const inputValue = e.target.value
                if (inputValue == "") {
                    if (!mobileFormSubmit.hasClass("disabled")) mobileFormSubmit.addClass("disabled")
                } else {
                    if (mobileFormSubmit.hasClass("disabled")) mobileFormSubmit.removeClass("disabled")
                }
            });
        }
    })

    mobileSearchModal.on('hidden.bs.modal', function(){
        mobileSearchInput.val('')
        mobileFormSubmit.addClass("disabled")
    })

    mobileFormSubmit.on('click', function(e){
        if ($(e.currentTarget).hasClass("disabled")) return
        const form = $("#searchContentMobile")[0]
        onFormSubmit(form)
    })
}

function manageDesktopClickOutOfOpenSearch(e){
    if (desktopSearchFormList.hasClass("show-search-form")){
        const target = $(e.target)
        if (target.parents('#seachContentDesk').length){
            return
        }
        closeDesktopSearchBar()
    }
}

function closeDesktopSearchIfIsOpen(){
    if (desktopSearchFormList.hasClass("show-search-form")){
        closeDesktopSearchFrom()
    }
}

function closeDesktopSearchBar(){
    const controller = new AbortController();
    const input = $(".desktop-li-seach-form form .input-group")
    input[0].addEventListener(
        "transitionend",
        function(){
            navItemsRegular.css("display", "flex")
            desktopSearchFormList.removeClass("show-search-form")
            $(".desktop-li-seach-form form .input-group").removeClass("close")
            controller.abort()
        },
        { signal: controller.signal }
    )
    input.addClass("close")
    $("body").off("click", manageDesktopClickOutOfOpenSearch)
}

function openDesktopSearchForm(){
    navItemsRegular.css("display", "none")
    desktopSearchFormList.addClass("show-search-form")
    deskSearchInput.focus()

    $("body").on("click", manageDesktopClickOutOfOpenSearch)
    
    if(deskSearchInputMustBeInit){
        deskSearchInputMustBeInit = false
        deskFormSubmit.on('click', function(e){
            if ($(e.currentTarget).hasClass("disabled")) {
                closeDesktopSearchBar()
                return
            }
            const form = $("#seachContentDesk")[0]
            onFormSubmit(form)
        })
        deskSearchInput.on("input", function(e){
            const inputValue = e.target.value
            if (inputValue == "") {
                if (!deskFormSubmit.hasClass("disabled")) deskFormSubmit.addClass("disabled")
            } else {
                if (deskFormSubmit.hasClass("disabled")) deskFormSubmit.removeClass("disabled")
            }
        });
    }
}

function closeDesktopSearchFrom(){
    desktopSearchFormList.removeClass("show-search-form")
    navItemsRegular.css("display", "flex")
    deskSearchInput.val('')
    deskFormSubmit.addClass("disabled")
}

function manageVirtualKeyboard(){
    if (window.visualViewport) {
        const vv = window.visualViewport;
        const searchEl = document.querySelector(".mob-search-btn-col");
        if (!searchEl) return

        function fixPosition() {
            const top = vv.height - 32;
            const search = $(".mob-search-btn-col");
            if (search.length){
                search.css("top", `${top}px`)
            }
        }  

        vv.addEventListener('resize', fixPosition);
        // Make sure we call it once before resizing too
        fixPosition();
    }
}

function onFormSubmit(form){
    const formData = new FormData(form)
    const userInput = formData.get('searchH')
    
    // Remove potentially harmful characters and sequences, excluding spaces
    var sanitizedInput = userInput.replace(/[^a-z0-9\s]/gi, ''); // Allow only alphanumeric characters and spaces

    // Build URL with sanitized input
    var finalUrl =searchLink + '?s=' + encodeURIComponent(sanitizedInput);

    // const url = searchLink + '?s=' + formData.get('searchH')
    window.location.href = finalUrl
}

function createElementAndFocus(){
    // trick to show keyboard on iPhone, from https://stackoverflow.com/a/55425845
    // create an 'invisible' input element and move focus on it, virtual-keyboard appears
    // then on modal open (see mobileFormInit) we move focus on real input
    // 
    // simply use .focus() on element doesn't work on iPhone if not directly linked to a user action
    // and our mobileSearchId element is not visible, modal is hidden, whe user click on lens
    const el = document.getElementById(mobileSearchId);
    tempMobileElement = document.createElement("input");
    tempMobileElement.classList.add("mytemphidden");

    tempMobileElement.style.position = "absolute";
    tempMobileElement.style.top = el.offsetTop + 7 + "px";
    tempMobileElement.style.left = el.offsetLeft + "px";
    tempMobileElement.style.height = 0;
    tempMobileElement.style.width = 0;
    tempMobileElement.style.opacity = 0;
    document.body.appendChild(tempMobileElement);
    tempMobileElement.focus();
}

// --- search functions end ---

export function closeMobileNavbar(){
    const bsCollapse = Collapse.getInstance('#navbarSupportedContent')
    if (bsCollapse) bsCollapse.hide()
}

function manageSearch(){
    formSubmitInit()
    mobileFormInit()

    $(desktopSearchSelector).on('click', function(e){
        e.stopPropagation()
        openDesktopSearchForm()
    })

    $(mobileSearchSelector).on('click', function(){
        var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
        if (iOS){
            createElementAndFocus()
        }
        mobileSearchModal.modal("show")
    })

}

function handleNavBarBehaviour(){
    handleMobileNavBarOpen()
    handleDesktopNavBarScroll()
}

function attachLoggedBtnClick(){
    $(".navbar-logged-cta-btn-ref").on('click', function(e){
        // normally this element is a anchor with an href, 
        // so user go to desired link.
        // Use some logic here with
        // e.preventDefault()
        // to change behaviour

        return
    })
}

export function initNavbar(){   
    // mix
    handleNavBarBehaviour()
    
    // visitor
    attachSignInRedirect()      // buy button
    attachNavBarLoginClick()    // login
    attachDocumentLeaveForRetarget()    // pages that not use initNavbar don't need to disable leaving-User-modal with disableLeavingUserModal
    
    // logged
    manageSearch()
    attachLogout()
    attachLoggedBtnClick()
}

export function initNavbarVisitor(){   
    // mix
    handleNavBarBehaviour()
    
    // visitor
    attachSignInRedirect()      // buy button
    attachNavBarLoginClick()    // login
    attachDocumentLeaveForRetarget()
}